module.exports = __webpack_public_path__ + "static/images/chat.1vcLKjV.svg";